/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ImageQuality = {
    Auto: 'Auto',
    High: 'High',
    Medium: 'Medium',
    Low: 'Low'
} as const;
export type ImageQuality = typeof ImageQuality[keyof typeof ImageQuality];


export function instanceOfImageQuality(value: any): boolean {
    for (const key in ImageQuality) {
        if (Object.prototype.hasOwnProperty.call(ImageQuality, key)) {
            if (ImageQuality[key as keyof typeof ImageQuality] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImageQualityFromJSON(json: any): ImageQuality {
    return ImageQualityFromJSONTyped(json, false);
}

export function ImageQualityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageQuality {
    return json as ImageQuality;
}

export function ImageQualityToJSON(value?: ImageQuality | null): any {
    return value as any;
}

export function ImageQualityToJSONTyped(value: any, ignoreDiscriminator: boolean): ImageQuality {
    return value as ImageQuality;
}

